<template>
  <div class="c-contact-item">

    <template v-if="icon === 'mobile'">
      <img class="item-icon" src="@/assets/icon/icon_tel.svg" />
      <span class="item-label">{{ label }}</span>
    </template>

    <template v-if="icon === 'email'">
      <img class="item-icon" src="@/assets/icon/icon_mail.svg" />
      <a class="item-label" :href="`mailto:${label}`">{{ label }}</a>
    </template>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ContactItem',
  props: {
    icon: {
      type: String,
      default: 'mobile',
    },
    label: {
      type: String,
      default: '',
    },
  },
});
</script>
<style lang="scss" scoped>
.c-contact-item {
  @include flex();
}
.item-label {
  @include font-normal();
  margin-left: 10px;
}
</style>
